import { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { useAppSelector } from '../../../../app/hook';
import { useGetEntityCountUsersQuery, useGetEntityPreferencesQuery, useGetEntityQuery } from '../../../../app/services/sum-rtk.service';
import { selectSUMEntityIdentification } from '../../../../features/sum/sum.slice';

export default function EntityDetail({ onLogouEntity }: { onLogouEntity: () => void }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentScenarioId = useAppSelector(state => state.bots.wizard.id);

  useEffect(() => {
    let item = false;
    const sessionData: any = localStorage.getItem(`LB_SUM_token_${currentScenarioId}`);
    if (sessionData) {
      item = true;
      const { exp, rememberMe, ...rest } = JSON.parse(sessionData);
      if (!(item && new Date(exp) >= new Date())) {
        // dispatch(logoutSUM());
        onLogouEntity();
        return;
      }
    }

    return () => {
      item = false;
    };
  }, [localStorage]);

  const entityIdentification = useSelector(state => selectSUMEntityIdentification(state, currentScenarioId));

  const { data, isLoading } = useGetEntityQuery({
    entityIdentification: entityIdentification,
  });

  const { data: dataPreferences, isLoading: isLoadingPreferences } = useGetEntityPreferencesQuery({
    entityIdentification: entityIdentification,
  });
  const { data: dataCountUsers, isLoading: isLoadingCountUsers } = useGetEntityCountUsersQuery({
    entityIdentification: entityIdentification,
  });

  return (
    <>
      <div className="tw-h-20 tw-p-4 tw-bg-white tw-rounded-lg tw-border tw-border-gray-300 tw-flex-col tw-justify-start tw-items-start tw-gap-2.5 tw-inline-flex tw-w-full tw-relative">
        {(isLoading || isLoadingPreferences || isLoadingCountUsers) && (
          <div className="tw-absolute tw-top-0 tw-self-center">
            <Spinner animation="border" size="sm" />
          </div>
        )}

        <div className="tw-self-stretch tw-justify-between tw-items-center tw-inline-flex">
          <div className="tw-h-10 tw-justify-start tw-items-center tw-gap-3 tw-flex">
            <div className="tw-w-10 tw-h-10 tw-justify-start tw-items-center tw-gap-5 tw-flex">
              <img src={dataPreferences?.cdn_logo_project_path} className="tw-w-10 tw-h-10 tw-bg-black/25 tw-rounded-full" alt="Entity logo" />
            </div>
            <div className="tw-flex-col tw-justify-center tw-items-start tw-gap-1 tw-inline-flex">
              <div className="tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{`${data?.entity_name}`}</div>
              <div className="tw-text-gray-500 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">{`${
                isLoadingCountUsers ? '' : dataCountUsers?.users
              } users`}</div>
            </div>
          </div>
          <div
            role="button"
            tabIndex={0}
            id="btn-logout-entity"
            onClick={() => onLogouEntity()}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                onLogouEntity();
              }
            }}
            className="tw-px-5 tw-py-3 tw-bg-red-600 tw-rounded-full tw-justify-center tw-items-center tw-flex tw-overflow-hidden"
          >
            <div className="tw-text-white tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{t('SuperUserManager/logout')}</div>
          </div>
        </div>
      </div>
      <div className="tw-h-10 tw-pl-2 tw-pr-3 tw-pt-4 tw-pb-2 tw-bg-gray-100 tw-rounded-bl-md tw-rounded-br-md tw-justify-start tw-items-center tw-gap-2.5 tw-inline-flex tw-w-full">
        <div className="tw-text-gray-500 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">{t('SuperUserManager/maxUsersCountHint')}</div>
      </div>
      <div className="tw-h-px tw-border tw-border-solid tw-border-gray-200 tw-w-full tw-mt-3"></div>
    </>
  );
}
